/* eslint-disable react-native/no-inline-styles */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react';
import { Text, View, Dimensions, PixelRatio, StyleSheet, ScrollView } from 'react-native';
import DeviceInfo from 'react-native-device-info';

import { isPhone } from '@helpers';

import {
  Element,
  baseDesign,
  stretchFactor,
  height,
  width,
  scaleFactor,
  fontScale,
  base,
  topOffsetForPosition,
  isChromeOS,
  ratio,
  notchTop,
  notchBottom,
  gcd,
} from '../../frame';
import ColorWrapper from '@styles/colors';

import { isIOS, isAndroid, textMargin, isWeb } from '@helpers';
import { font } from '@styles/fonts';

const formatNumber = (number, to = 2) => Number(number).toFixed(to);

const DevInfo = (props) => {
  const { C, scale } = props;
  const [deviceID, setDeviceID] = useState('');

  useEffect(() => {
    (async () => {
      const d = await DeviceInfo.getUniqueId();
      setDeviceID(d);
    })();
  }, []);

  const PRatio = PixelRatio.get();
  const DScrenWidth = Dimensions.get('screen').width;
  const DScrenHeight = Dimensions.get('screen').height;
  const platform = (() => {
    if (isWeb) {
      return 'Web';
    }
    if (isIOS) {
      return 'IOS';
    }
    if (isChromeOS) {
      return 'Chrome OS';
    }
    if (isAndroid) {
      return 'Android';
    }
    return 'unknown';
  })();
  const blocks = [
    {
      header: '',
      content: [
        {
          tile: 'Device ID',
          value: deviceID,
          long: true,
        },
        {
          tile: 'Platform',
          value: platform,
        },
        {
          tile: 'Color scheme',
          value: C.scheme,
        },
        {
          tile: 'Phone',
          value: `${isPhone}`,
        },
        {
          tile: 'Tablet',
          value: `${!isPhone}`,
        },
        {
          tile: 'Base resolution',
          value: `${baseDesign.width} x ${baseDesign.height}`,
        },
        {
          tile: 'Aspect ratio using resolution',
          value: `${formatNumber(width / gcd, 0)} : ${formatNumber(height / gcd, 0)}`,
        },
        {
          tile: 'Aspect ratio',
          value: formatNumber(ratio, 5),
        },
        {
          tile: 'Horizontal stretch factor',
          value: stretchFactor.horizontal,
        },
        {
          tile: 'Vertical stretch factor',
          value: stretchFactor.vertical,
        },
        {
          tile: 'Design resolution',
          value: `${formatNumber(base.w)} x ${formatNumber(base.h)}`,
        },
        {
          tile: 'Scale factor',
          value: formatNumber(scaleFactor),
        },
        {
          tile: 'Text size correction',
          value: fontScale,
        },
        {
          tile: 'Window using resolution',
          value: `${formatNumber(width)} x ${formatNumber(height)}`,
        },
        {
          tile: 'Window resolution',
          value: `${formatNumber(DScrenWidth)} x ${formatNumber(DScrenHeight)}`,
        },
        {
          tile: 'Pixel ratio',
          value: PRatio,
        },
        {
          tile: 'Device using resolution',
          value: `${formatNumber(PRatio * width)} x ${formatNumber(PRatio * height)}`,
        },
        {
          tile: 'Device resolution',
          value: `${formatNumber(PRatio * DScrenWidth)} x ${formatNumber(PRatio * DScrenHeight)}`,
        },
      ],
    },
    {
      header: 'DESIGN - WINDOW - DEVICE - OFFSETS',
      content: [
        {
          tile: 'Status bar offset (pixels)',
          value: `${formatNumber(topOffsetForPosition)} (${formatNumber(topOffsetForPosition * PRatio)})`,
        },
        {
          tile: 'Don’t use top',
          value: `${formatNumber(notchTop / scaleFactor)}-${formatNumber(notchTop)}-${formatNumber(PRatio * notchTop)}`,
        },
        {
          tile: 'Don’t use bottom',
          value: `${formatNumber(notchBottom / scaleFactor)}-${formatNumber(notchBottom)}-${formatNumber(PRatio * notchBottom)}`,
        },
        {
          tile: 'Can’t use on top (pixels)',
          value: `${formatNumber(topOffsetForPosition)} (${formatNumber(topOffsetForPosition * PRatio)})`,
        },
        {
          tile: 'Can’t use at bottom (pixels)',
          value: `${isWeb || isIOS ? 0 : formatNumber(DScrenHeight - height - notchTop - notchBottom)} (${
            isWeb || isIOS ? 0 : formatNumber((DScrenHeight - height - notchTop - notchBottom) * PRatio)
          })`,
        },
        {
          tile: 'Can’t use on sides',
          value: isWeb && width >= 1080 ? DScrenWidth - width : 0,
        },
      ],
    },
  ];

  return (
    <Element
      {...{
        config: {
          position: {
            top: 162,
            bottom: '0%',
          },
          width: 440,
          horizontalCenter: 0,
        },
        configMobile: {
          position: {
            top: 179,
            bottom: '0%',
          },
          width: 360,
        },
      }}
    >
      <ScrollView
        style={{
          width: '100%',
          paddingLeft: scale(16),
          paddingRight: scale(16),
        }}
      >
        {blocks.map((item, index) => (
          <View key={`block-${index}`}>
            {!!item.header && (
              <Text
                style={{
                  color: C('Label / Light / Secondary'),
                  fontSize: scale(13),
                  textTransform: 'uppercase',
                  paddingLeft: scale(22),
                  marginBottom: textMargin(scale(9)),
                }}
              >
                {item.header}
              </Text>
            )}
            <View
              style={{
                width: '100%',
                borderRadius: scale(10),
                backgroundColor: C('Background / Light / Field'),
                marginBottom: scale(27),
              }}
            >
              {item.content.map((el, pos) => (
                <View
                  key={el.tile}
                  style={{
                    width: '100%',
                    paddingLeft: scale(15),
                    height: scale(el.long ? 52 : 44),
                  }}
                >
                  <View
                    style={{
                      width: '100%',
                      height: '100%',
                      flexDirection: el.long ? 'column' : 'row',
                      justifyContent: el.long ? 'center' : 'space-between',
                      alignItems: 'center',
                      borderBottomColor: 'rgba(0, 0, 0, 0.15)',
                      borderBottomWidth: item.content.length - 1 !== pos ? StyleSheet.hairlineWidth : 0,
                    }}
                  >
                    <Text
                      style={[
                        font['Body'],
                        {
                          color: C('Label / Light / Primary'),
                        },
                        el.long && { width: '100%', textAlign: 'left' },
                      ]}
                    >
                      {el.tile}
                    </Text>
                    <Text
                      style={[
                        font[el.long ? 'Caption 1' : 'Body'],
                        {
                          paddingRight: scale(15),
                          color: C('Label / Light / Secondary'),
                          textAlign: 'right',
                        },
                        el.long && { width: '100%', textAlign: 'left' },
                      ]}
                    >
                      {el.value}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </View>
        ))}
      </ScrollView>
    </Element>
  );
};

export default ColorWrapper(DevInfo);
